import {
  calculateCac,
  calculateRoas,
  safeDivide,
  safeSubtract,
} from "@north-beam/nb-common";

import { roundPotentiallyInfiniteNumber } from "./formatters";

export function getFractionChanged({
  current,
  historical,
}: {
  current: number;
  historical: number;
}) {
  return safeDivide(
    safeSubtract(current, historical, { infMinusInf: 0 }),
    historical,
    { zeroOverZero: 0, infOverInf: 0 },
  );
}

export function calculateAndFormatRoas({
  revenue,
  spend,
  decimalPlaces = 1,
}: {
  revenue: number;
  spend: number;
  decimalPlaces?: number;
}) {
  return roundPotentiallyInfiniteNumber(
    calculateRoas({ revenue, spend }),
    decimalPlaces,
  );
}

export function caclulateAndFormatCac({
  transactions,
  spend,
  decimalPlaces = 2,
}: {
  transactions: number;
  spend: number;
  decimalPlaces?: number;
}) {
  return roundPotentiallyInfiniteNumber(
    calculateCac({ transactions, spend }),
    decimalPlaces,
  );
}
